import { ImLocation2 } from 'react-icons/im';
import React, { useState } from 'react';
import contactBg from '../images/contact-bg.jpg';
import Zoom from 'react-reveal/Zoom';
import Bounce from 'react-reveal/Bounce';
import Fade from 'react-reveal/Fade';
import { Helmet } from 'react-helmet';
import { navigate } from '@reach/router';

function Contact() {
  const [status, setStatus] = useState('');
  const [sending, setSending] = useState(false);

  const submitForm = (ev) => {
    ev.preventDefault();
    setSending(true);
    const form = ev.target;
    const data = new FormData(form);
    const xhr = new XMLHttpRequest();
    xhr.open(form.method, form.action);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.onreadystatechange = () => {
      if (xhr.readyState !== XMLHttpRequest.DONE) return;
      if (xhr.status === 200) {
        form.reset();
        setStatus('SUCCESS');
        setSending(false);
        navigate('/thankYou');
      } else {
        setStatus('ERROR');
        setSending(false);
      }
    };
    xhr.send(data);
  };

  return (
    <div id='contact-us' style={{ backgroundImage: `url(${contactBg})` }}>
      <Helmet>
        <title>Contact | Solaric</title>
      </Helmet>
      <div className='container px-5'>
        <div className='row header-title text-center'>
          <div className='col-md-8 col-lg-6 mx-auto'>
            <h1 className='mt-5'>
              <Zoom left>
                <span>Contact US</span>
              </Zoom>
            </h1>
            <h4 className='text-white px-5 mt-2'>Reach out for a new project or just say hello</h4>
          </div>
        </div>

        <div className='row contact-container mt-5'>
          <div className='col-md-6 first-col'>
            <div className='heading-content mb-4'>
              <Bounce>
                <h4>Send us message</h4>
              </Bounce>
            </div>
            <form onSubmit={submitForm} action='https://formspree.io/mvoddaaq' method='POST'>
              <Bounce left>
                <div className='mb-3'>
                  <input required placeholder='Your name' type='text' className='form-control' name='name' id='name' />
                </div>
              </Bounce>
              <Bounce left>
                <div className='mb-3'>
                  <input
                    required
                    placeholder='Your email'
                    type='email'
                    className='form-control'
                    name='email'
                    id='email'
                  />
                </div>
              </Bounce>
              <Bounce left>
                <div className='mb-4'>
                  <textarea
                    required
                    name='Message'
                    className='form-control'
                    placeholder='Type your message..'
                    id='message'
                    style={{ minHeight: '100px' }}
                  ></textarea>
                </div>
              </Bounce>
              <Bounce bottom>
                <button className='btn btn-success' disabled={sending} type='submit' style={{ width: '100%' }}>
                  {sending ? 'Sending...' : 'Send'}
                </button>
              </Bounce>
            </form>
            <div className='response my-2 px-auto text-center'>
              {status === 'SUCCESS' && <p className='center'>Message sent! We'll response you ASAP!</p>}
              {status === 'ERROR' && <p className='center'>Ooops! There was an error.</p>}
            </div>
            <a href='tel:+01750 150 255' className='callNowButton'>
              Call: 01750 150 255
            </a>
          </div>
          <div className='col-md-6 second-col'>
            <div className='heading-content mb-4'>
              <Bounce>
                <h4>Contact Info</h4>
              </Bounce>
            </div>
            <Fade>
              <div className='contact-info'>
                <div className='cinfo'>
                  <h5>Find us at</h5>
                  <p>
                    <b>Bangladesh</b> <br /> Khandakar Tower, House: 2554, <br /> Madani Avenue Sayednagar, Vatara,
                    Dhaka-1212.
                  </p>
                  <p>
                    <b>Singapore</b>
                    <br /> 3 Shenton Way, #16-08, Shenton House, Singapore 068805
                  </p>
                  <p>
                    <b>USA</b>
                    <br /> 101 Arbor Way, Mipitas, CA 95035
                  </p>
                </div>
                <div className='cinfo'>
                  <h5>Email Us At</h5>
                  <p>megaroof@solaricglobal.com</p>
                </div>

                <div className='cinfo'>
                  <h5>Call Us At</h5>
                  <p>
                    <a href='tel:+01750 150 255'>
                      {' '}
                      <b>Bangladesh</b>: 01750 150 255
                    </a>
                  </p>
                  <p>
                    <a href='tel:+1 669 270 8699'>
                      <b>International</b>: +1 669 270 8699
                    </a>
                  </p>
                </div>

                <div className='mapLink mt-5'>
                  <a target='_blank' href='https://goo.gl/maps/3m65uGL9BafFiNu78'>
                    <ImLocation2 /> Locate us on map!
                  </a>
                </div>
              </div>
            </Fade>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
